import { Action, noAction } from 'src/framework'
import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { authResult, AuthService } from 'src/services/auth.service'
import { concat, from } from 'rxjs'
import { Deps } from 'src/app.store'
import { filter, mapTo, mergeMap, tap, throttleTime } from 'rxjs/operators'
import { LocationChangeAction, push } from 'connected-react-router'
import { loginActions, LoginActions } from './login.actions'
import { LoginState } from './login.reducer'
import { onForgotNoEmail, onLoginFailure } from './Login'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

type Actions = LoginActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<LoginState> {}

export interface LoginFailure {
  type: 'LoginFailure'
}

const authCall = (authService: AuthService) => (p: { [startFetch]: string; userName: string; password: string }) =>
  concat(
    from(
      authService
        .login(p.userName, p.password)
        .delayResult(1000)
        .map(auth =>
          authResult.is.Authenticated(auth)
            ? loginActions.LoginSuccess({
                companyId: auth.companyId,
                userName: p.userName,
                rights: auth.rights,
                token: auth.token,
                initials: auth.initials,
                [stopFetch]: p[startFetch]
              })
            : loginActions.LoginFailure({
                [stopFetch]: p[startFetch]
              })
        )
        .chain(x => authService.validateToken().map(() => x))
    )
  )

export const loginEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(loginActions.is.Login),
    mergeMap(authCall(deps.authService)),
    tap(result => {
      if (loginActions.is.LoginFailure(result)) {
        onLoginFailure()
      }
    })
  )
/*
    .filter(loginActions.is.Login)

    .mergeMap(authCall)
    .do(result => {
      if (loginActions.is.LoginFailure(result)) {
        onLoginFailure()
      }
    })
*/
export const loginSuccessGotoHomeEpic = (action$: Action$) =>
  action$.pipe(
    filter(loginActions.is.LoginSuccess),
    mapTo(noAction)
    //    mapTo(push('/home'))
  )

export const loginForgotPassordEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(loginActions.is.LoginForgotPassword),
    throttleTime(2000), // discard during 2 seconds
    mergeMap(({ email }) => from(deps.authService.lostPassword(email))),
    mapTo(noAction)
  )

export const loginForgotPassordNoLoginEpic = (action$: Action$) =>
  action$.pipe(
    filter(loginActions.is.LoginForgotPasswordNoEmail),
    tap(_ => {
      onForgotNoEmail()
    }),
    mapTo(noAction)
  )

export const logoutEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(loginActions.is.Logout),
    mergeMap(deps.authService.logout),
    mapTo(push('/login'))
  )

const isAuthenticated = (authService: AuthService) =>
  authService.currentAuth().map(auth =>
    authResult.is.Authenticated(auth)
      ? loginActions.LoginSuccess({
          companyId: auth.companyId,
          initials: auth.initials,
          userName: auth.email,
          rights: auth.rights,
          token: auth.token,
          [stopFetch]: 'none'
        })
      : loginActions.LoginFailure({
          [stopFetch]: 'none'
        })
  )

const isRouterAction = (action: LocationChangeAction | Action<any>): action is LocationChangeAction =>
  action.type === '@@router/LOCATION_CHANGE'

export const loginStartUp = (action$: ActionsObservable<LocationChangeAction | Action<any>>, _: State$, deps: Deps) =>
  action$.pipe(
    filter(isRouterAction),
    filter(action => action.payload.location.pathname === '/login'),
    mergeMap(_ => from(isAuthenticated(deps.authService)))
  )

export const loginEpics = combineEpics(
  loginStartUp,
  loginEpic,
  logoutEpic,
  loginSuccessGotoHomeEpic,
  loginForgotPassordEpic,
  loginForgotPassordNoLoginEpic
)



// WEBPACK FOOTER //
// ./src/users-components/login/login.epics.ts